import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetSelfAppAveragesSummaryRequestDto } from '../../../../interface/dtos/scores/get-self-app-averages-summary.request.dto';
import { SelfAppAverageSummaryEntity } from '../../../domain/entities/scores/self-app-average-summary.entity';
import { GetSelfAppAveragesSummaryDomainService } from '../../../domain/services/scores/get-self-app-averages-summary.domain-service';
import { AnalyticsActivityPort } from '../../ports/analytics-activity/analytics-activity.port';

export class GetSelfAppAveragesSummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: AnalyticsActivityPort,
    protected readonly domainService: GetSelfAppAveragesSummaryDomainService
  ) {}

  async execute(
    props: GetSelfAppAveragesSummaryRequestDto
  ): Promise<SelfAppAverageSummaryEntity> {
    try {
      const result = await this.port.queryCumulativeAvgDurations({
        date: props.params.endDate,
        appId: props.params.appId,
        token: props.config.token,
      });
      return this.domainService.execute({ entity: result });
    } catch (error) {
      throw new Error(
        `GetSelfAppAveragesSummaryApplicationService.execute encountered an error ${error}`
      );
    }
  }
}
